import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import Breadcrumbs from '@/atoms/Breadcrumb'
import useSearchProducts from '@/hooks/useSearchProducts'
import NoResultsPlaceholder from '@/molecules/NoResultPlaceholder'
import CreatorSlider from '@/organisms/CreatorSlider'
import ProductsGrid from '@/organisms/ProductsGrid/ProductsGrid'
import Creator from '@/ts/Creator'
import FansiKind from '@/ts/enums/global/FansiKind'
import ProductType from '@/ts/enums/product/ProductType'
import FilterGroup from '@/ts/interfaces/global/FilterGroup'
import Product from '@/ts/Product'
import Presentation from '@/views/common/Presentation'

function SearchView(props: SearchViewProps) {
  const { t } = useTranslation('global')
  const { filters } = props

  const {
    query: { q },
  } = useRouter()

  const { products, creators, count, maxPrice, isLoading } = useSearchProducts()

  const noResults = !isLoading && count <= 0
  const shouldDisplayContent = count > 0 && products.length > 0

  // useEffect(() => {
  //   if (products.length > 0) {
  //     GTM.pushCategory(products, fansiKind)
  //   }
  // }, [products.length])

  return (
    <div>
      <Breadcrumbs
        crumbs={[
          {
            label: `${t('search')} "${q}"`,
          },
        ]}
        className="mb-8"
      />
      <div className="space-y-10 md:space-y-20">
        {!!creators?.length && (
          <div className="space-y-0">
            <h1 className="text-2xl font-medium box">Znalezieni twórcy</h1>
            <CreatorSlider creators={creators} />
          </div>
        )}
        {q?.length ? (
          <Presentation
            title={'all_products_search'}
            totalItems={count}
            noResults={noResults}
            filters={filters}
            maxPrice={maxPrice}
            shouldDisplayContent={shouldDisplayContent}
          >
            <ProductsGrid products={products} asFeatured />
          </Presentation>
        ) : (
          <NoResultsPlaceholder />
        )}
      </div>
    </div>
  )
}

interface SearchViewProps {
  filters: FilterGroup
  bestsellers?: Product[]
  creators?: Creator[]
  upcoming?: Product[]
  productType: ProductType
  fansiKind: FansiKind
}

export default SearchView
